import { Autocomplete, AutocompleteOption, VariantProp } from '@healthinal/ui';
import { useGetCountries } from '../../api/generated/locale-controller/locale-controller.ts';
import { LocaleDto } from '../../api/generated/model';

interface Props {
  onChange: (localeDto: LocaleDto | null) => void;
  value: LocaleDto | null;
  variant?: VariantProp;
}
export function SelectCountry({ onChange, value, variant }: Props) {
  const { data: countries, isPending } = useGetCountries();

  return (
    <Autocomplete
      value={value}
      onChange={(_, value) => onChange(value)}
      loading={isPending}
      options={countries ?? []}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, value) => option.isoCode === value.isoCode}
      renderOption={(props, option) => (
        <AutocompleteOption {...props} key={option.isoCode}>
          {option.name}
        </AutocompleteOption>
      )}
      variant={variant}
    />
  );
}
